import { REGIONY } from '../../components/wykonawcy/regionyPolski'

/**
 * Opisy po polsku: skąd silnik (`lib/ekonomiaKlienta.js`, pole `zrodlaDanych`) wziął produkcję, koszt, zużycie
 * i ceny. Jedno miejsce dla karty klienta i dla PDF-a oferty, żeby ta sama liczba miała w obu ten sam podpis.
 */

export const nazwaWojewodztwa = (klucz) => REGIONY.find((r) => r.key === klucz)?.nazwa || ''

/** Przymiotnik do „województwa”: Łódzkie → łódzkiego (wystarczy dla zapisu „dla województwa łódzkiego”). */
const dopelniacz = (nazwa) => String(nazwa || '').toLowerCase().replace(/ie$/, 'iego')

/**
 * Skąd produkcja: „Projekt 3D, z uwzględnieniem cienia” albo „średnia dla województwa łódzkiego”.
 * `zrodlaDanych` to wynik `ekonomiaKlienta(...).zrodlaDanych`, `wojewodztwo` jego pole `wojewodztwo`
 * (klucz) albo null, gdy lokalizacji nie znamy.
 */
export const opisZrodlaProdukcji = (zrodlaDanych, wojewodztwo = null) => {
  const z = zrodlaDanych?.produkcja
  if (z === '3d') return 'Projekt 3D, z uwzględnieniem cienia'
  if (z === '3d_przeskalowana') return 'Projekt 3D, z uwzględnieniem cienia, przeliczona na moc zestawu'
  if (z === 'tabela') {
    const nazwa = nazwaWojewodztwa(wojewodztwo)
    if (zrodlaDanych.lokalizacja === 'domyslna' || !nazwa) {
      return 'średnia dla województwa mazowieckiego, bo lokalizacja nie jest podana'
    }
    return `średnia dla województwa ${dopelniacz(nazwa)}`
  }
  return ''
}

const KOSZT = {
  cena_klienta: 'cena dla klienta z karty',
  wpisana: 'kwota wpisana ręcznie',
  cena_oferty: 'cena z oferty',
  zestaw: 'suma zestawu z montażem',
  widelki: 'podane widełki ceny',
  typowe_widelki: 'typowe widełki, bo nie ma ceny dla klienta',
}
export const opisZrodlaKosztu = (zrodlaDanych) => KOSZT[zrodlaDanych?.koszt] || ''

const ZUZYCIE = {
  kwh: 'roczne zużycie z karty',
  rachunek: 'miesięczny rachunek przeliczony na kWh',
  osoby: 'liczba osób w domu',
}
export const opisZrodlaZuzycia = (zrodlaDanych) => ZUZYCIE[zrodlaDanych?.zuzycie] || ''

export const opisZrodlaCen = (zrodlaDanych) => (zrodlaDanych?.ceny === 'klient'
  ? 'ceny energii podane dla klienta'
  : 'założenia serwisu')

/**
 * Czego brakuje do policzenia, konkretnie i po polsku (`ekonomiaKlienta(...).brakuje`). Pusta lista, gdy
 * wszystko jest. Każdy wpis ma kierunek: co wpisać albo podpiąć.
 */
export const opisBrakow = (brakuje = []) => brakuje.map((b) => ({
  zuzycie: 'Brakuje zużycia prądu: wpisz roczne zużycie, miesięczny rachunek albo liczbę osób w domu.',
  produkcja: 'Brakuje mocy instalacji: podepnij zestaw z modułami albo wpisz moc PV w danych klienta.',
  koszt: 'Brakuje ceny: wpisz cenę dla klienta albo podepnij zestaw z cenami.',
}[b])).filter(Boolean)
